var _defs, _path, _path2, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _path3, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlluStatusDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 133.892,
    height: 152.147,
    viewBox: "0 0 133.892 152.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_4062",
    x: 31.706,
    y: 22.843,
    width: 73.3,
    height: 116.452,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_4063",
    x: 27.289,
    y: 21.237,
    width: 76.988,
    height: 118.251,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_4064",
    x: 38.205,
    y: 59.139,
    width: 35,
    height: 71.494,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_4065",
    x: 56.206,
    y: 42.37,
    width: 46,
    height: 61.778,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_4066",
    x: 71.206,
    y: 74.315,
    width: 31,
    height: 37.214,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_4067",
    x: 56.305,
    y: 82.793,
    width: 32.15,
    height: 37.717,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0057ff",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3811",
    "data-name": "Gruppe 3811",
    transform: "translate(-992.221 -244.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3810",
    "data-name": "Gruppe 3810",
    transform: "translate(992.221 244.422)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4060",
    "data-name": "Pfad 4060",
    d: "M1.383,114.77l.4-.235L.505,39.279,67.032.579l66.36,38.7v76l-66.36-38.7,65.485,38.195-65.486,36.8Z",
    fill: "#0057ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4061",
    "data-name": "Pfad 4061",
    d: "M1.383,114.77l.4-.235L.505,39.279,67.032.579l66.36,38.7v76l-66.36-38.7,65.485,38.195-65.486,36.8Z",
    fill: "none",
    stroke: "#0057ff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1107",
    "data-name": "Rechteck 1107",
    width: 133.892,
    height: 152.147,
    fill: "none"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1108",
    "data-name": "Rechteck 1108",
    width: 133.892,
    height: 152.147,
    transform: "translate(992.221 244.422)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 992.22, 244.42)",
    filter: "url(#Pfad_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4062-2",
    "data-name": "Pfad 4062",
    d: "M42.752,59.277l50.257-29.23a1.329,1.329,0,0,1,2,1.149V94.675a2.106,2.106,0,0,1-1.046,1.819l-51.013,29.67a.826.826,0,0,1-1.241-.714V61.1A2.1,2.1,0,0,1,42.752,59.277Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0057ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 992.22, 244.42)",
    filter: "url(#Pfad_4063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4063-2",
    "data-name": "Pfad 4063",
    d: "M42.206,126.185l-3.671-1.493a2,2,0,0,1-1.246-1.853V59.733a2.1,2.1,0,0,1,1.046-1.819L87.706,28.779a3.554,3.554,0,0,1,3.416-.1l2.841,1.22",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0057ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 992.22, 244.42)",
    filter: "url(#Pfad_4064)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4064-2",
    "data-name": "Pfad 4064",
    d: "M61.742,110.264l-12.006,7.2a1.011,1.011,0,0,1-1.531-.867V76.21a3.22,3.22,0,0,1,1.566-2.763l11.9-7.143a1.01,1.01,0,0,1,1.53.866v40.508A3.016,3.016,0,0,1,61.742,110.264Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0057ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 992.22, 244.42)",
    filter: "url(#Pfad_4065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4065-2",
    "data-name": "Pfad 4065",
    d: "M90.781,77.707,67.76,90.988a1.036,1.036,0,0,1-1.554-.9V65.7a3.663,3.663,0,0,1,1.832-3.172L90.551,49.54a1.1,1.1,0,0,1,1.655.956V75.239A2.849,2.849,0,0,1,90.781,77.707Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0057ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 992.22, 244.42)",
    filter: "url(#Pfad_4066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4066-2",
    "data-name": "Pfad 4066",
    d: "M90.874,93.672l-7.907,4.672a1.167,1.167,0,0,1-1.761-1.005V89.367a3.35,3.35,0,0,1,1.607-2.861l8.324-5.07a.7.7,0,0,1,1.069.6v9.3A2.712,2.712,0,0,1,90.874,93.672Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0057ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 992.22, 244.42)",
    filter: "url(#Pfad_4067)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4067-2",
    "data-name": "Pfad 4067",
    d: "M77.132,102.308l-9.319,5.059a1.021,1.021,0,0,1-1.508-.9V97.311a1.785,1.785,0,0,1,.888-1.542l10.065-5.85a.8.8,0,0,1,1.2.691v9.406A2.647,2.647,0,0,1,77.132,102.308Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#0057ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4068",
    "data-name": "Pfad 4068",
    d: "M37.289,67.305l4.052,1.946,53.665-30.6",
    transform: "translate(992.221 244.422)",
    fill: "none",
    stroke: "#0057ff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1109",
    "data-name": "Rechteck 1109",
    width: 133.892,
    height: 152.147,
    transform: "translate(992.221 244.422)",
    fill: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1110",
    "data-name": "Rechteck 1110",
    width: 133.892,
    height: 152.147,
    transform: "translate(992.221 244.422)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluStatusDashboard);
export default __webpack_public_path__ + "static/media/illu-status-dashboard.1b9b767273390f39b2c3fbb2e7fb8312.svg";
export { ForwardRef as ReactComponent };